import React, { useCallback, useEffect, useState } from 'react';
import { Dropdown, Header4, LoadingAnimation, useFormContextRequired, Text } from 'ui-builder';
import { DetailsFieldsSet, ProjectType, useDetailFieldSetsAdminService } from 'nekst-api';
import { useProjectTypeHelper } from 'features/tasks-forms';
import { debounce } from 'lodash';

function ProjectTypeSetsDropdown(
  props: {
    projectType: ProjectType,
    sets: DetailsFieldsSet[],
  }
) {
  const toCamelCase = (str: string) =>
    str.toLowerCase()
      .replace(/_([a-z])/g, (_, c) => c.toUpperCase());

  const source = `${toCamelCase(props.projectType)}SetId`;

  const projectTypeHelper = useProjectTypeHelper();

  return (
    <Dropdown
      options={
        props
          .sets
          .filter((item) => item.projectType === props.projectType)
          .map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          })
      }
      source={source}
      label={projectTypeHelper.getLabel(props.projectType)}
    />
  );
}

export default function DetailsFieldsSetDropdowns() {
  const formContext = useFormContextRequired<{ teamId?: number }>();

  const teamId = formContext.data?.teamId;

  const [sets, setSets] = useState<DetailsFieldsSet[]>();

  const detailFieldSetsAdminService = useDetailFieldSetsAdminService();

  async function loadSetsFunc(id?: number) {
    if (id) {
      setSets(await detailFieldSetsAdminService.getDetailFieldSetsByTeamId(id))
    } else {
      setSets([]);
    }
  }

  const loadSets = useCallback(
    debounce(loadSetsFunc, 500),
    []
  );

  useEffect(() => {
    formContext.onChangeCallback({
      listingSetId: undefined,
      pendingBuyerSetId: undefined,
      pendingSellerSetId: undefined,
      pendingDualSetId: undefined,
      otherSetId: undefined,
      activeBuyerSetId: undefined
    });

    loadSets(teamId);
  }, [teamId]);

  if (sets) {
    if (sets.length > 0) {
      return (
        <>
          <Header4>Choose Set for each Transaction Type</Header4>
          <ProjectTypeSetsDropdown projectType={ProjectType.LISTING} sets={sets} />
          <ProjectTypeSetsDropdown projectType={ProjectType.PENDING_BUYER} sets={sets} />
          <ProjectTypeSetsDropdown projectType={ProjectType.PENDING_SELLER} sets={sets} />
          <ProjectTypeSetsDropdown projectType={ProjectType.PENDING_DUAL} sets={sets} />
          <ProjectTypeSetsDropdown projectType={ProjectType.OTHER} sets={sets} />
          <ProjectTypeSetsDropdown projectType={ProjectType.ACTIVE_BUYER} sets={sets} />
        </>
      )
    } else {
      return (
        <>
          <Header4>Choose Set for each Transaction Type</Header4>
          <Text>Choose Team To Select Detail Fields Sets</Text>
        </>
      )
    }
  } else {
    return (<LoadingAnimation />);
  }
}
